var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.running,
      expression: "running"
    }],
    staticClass: "speechBar",
    class: {
      running: _vm.running
    }
  }, [_c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };